import axios from "axios";
import {ENV_VARIABLES} from "../utils/envVariables";

axios.defaults.baseURL = ENV_VARIABLES.API_URL;